import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import React, { useState, useEffect } from "react";
import { Formik } from 'formik';
import { toast } from "react-toastify";
import ErrorMessage from "../components/ErrorMessage";
import { NoAuthApiRequest, ApiRequest } from "./services/apiservice";
import { ApiEndpoints, ApiEndpointMethod } from "../utils/endpoints";
import { useNavigate } from "react-router";
import { addClient } from "../utils/schema";
import { Tooltip } from 'react-tooltip';
import Loader from './shared/loader'

const Clients = () => {
    const [loader, setloader] = useState(false);
    const [clientIds, setclientIds] = useState(0);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50); // Default page size
    const [totalPages, setTotalPages] = useState(0);

    const [startCount, setstartCount] = useState("");
    const [endCount, setendCount] = useState("");
    const [totalCount, settotalCount] = useState("");
    const [lstClient, setlstClient] = useState([]);
    const [search, setsearch] = useState('');
    const [projectDetails, setprojectDetails] = useState();

    const [formData, setFormData] = useState({
        Email: '',
        ClientName: '',
        CompanyName: '',
        TimeZone: '',
        Id: 0,
        UserId: -1,
    });

    useEffect(() => {

        const fetchData = async () => {
            await fetchClientsList();
        };
        fetchData();

    }, []);

    const fetchClientsList = async () => {

        await fetchClients(1, pageSize);
    }

    const handleKeyPress = async (event) => {
        // Check if the pressed key is Enter (keyCode 13)
        if (event.key === 'Enter') {
            await fetchClients(1, pageSize);
            // You can trigger any logic here when Enter is pressed
        }
    };

    const handleChanges = (event) => {
        setsearch(event.target.value);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchClients(page, pageSize);
    };

    const fetchProjectDetails = async (projectId) => {
        //alert(projectId);
         setloader(true);

        const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectDetails(projectId), ApiEndpointMethod.Post, navigate);
        if (data != null && data.success == true) {
            setprojectDetails(data.message);
             setloader(false);

        }
        else if(data != null && data.success == false) {
            toast.error(data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setloader(false);
        }
    }


    const fetchClients = async (page, limit) => {

        try {
            setloader(true);


            const data = await ApiRequest(ApiEndpoints.Entity.FetchclientList(page, limit, search), ApiEndpointMethod.Get, null, navigate);


            await setlstClient(data.Item1);
            const totalPages = Math.ceil(data.Item2 / limit);
            setTotalPages(totalPages);

            const startcount = Math.ceil(
                Math.ceil(Math.ceil(page * limit) - limit) + 1
            );
            let endcount = Math.ceil(page * limit);
            if (endcount > data.Item2) {
                endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
            }
            setstartCount(startcount);
            setendCount(endcount);
            settotalCount(data.Item2);

            return { data };
            // Handle the response data here (e.g., show success message or update UI)
        } catch (error) {
            console.error("Error during API call:", error);
            // await setfileList([]);
            // Handle errors (e.g., show an error message to the user)
        }
        finally {
            setloader(false);
        }
    };

    const getPageNumbers = () => {
        // Dynamically generate page numbers
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
        let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleChangeTigger = (name, value) => {

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };



    const updatePreRow = (id, updatedData) => {

        setlstClient(prevRows =>
            prevRows.map(row =>
                row.Id === id ? { ...row, IsExpend: updatedData } : row
            )
        );
        setclientIds(id);
    };

    const updateRow = (id, updatedData) => {
        updatePreRow(clientIds, false);
        setlstClient(prevRows =>
            prevRows.map(row =>
                row.Id === id ? { ...row, IsExpend: updatedData } : row
            )
        );
        setclientIds(id);
    };

    const typeLabels = {
        1: 'Fixed',
        2: 'Billable',
        3: 'Support'
    };

    const statusLabels = {
        1: 'Active',
        2: 'InActive',
        3: 'Completed',
        4: 'Hold'
    };

    const formatDateUTCDate = (dateString) => {
        if (dateString != "" && dateString != undefined && dateString != null) {
            const date = new Date(dateString);

            // Adjust to local time
            const month = date.getMonth() + 1; // Months are zero-indexed
            const day = date.getDate();
            const year = date.getFullYear();

            return `${month}/${day}/${year}`;
        }
        else {
            return '';
        }
    }

    const clear = async () => {

        await handleChangeTigger("Id", 0);
        await handleChangeTigger("ClientName", '');
        await handleChangeTigger("CompanyName", '');
        await handleChangeTigger("Email", '');
        await handleChangeTigger("TimeZone", '');
        await handleChangeTigger("UserId", -1);
    }
    const EditClient = async (clientId) => {

        document.getElementById('mdlAddClient').click();

        const data = await ApiRequest(ApiEndpoints.Entity.GetClientDetails(clientId), ApiEndpointMethod.Get, navigate);
        if (data != null) {
            await handleChangeTigger("Id", data.Id);
            await handleChangeTigger("ClientName", data.ClientName);
            await handleChangeTigger("CompanyName", data.CompanyName);
            await handleChangeTigger("Email", data.Email);
            await handleChangeTigger("TimeZone", data.TimeZone);
            //alert(data);
        }
    };

    const validateEmail = (email) => {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        if (!emailReg.test(email)) {
            return false;
        } else {
            return true;
        }
    }

    const CreateClient = async (validateForm, setTouched, values) => {
        try {
            const errors = await validateForm();
            // if (Object.keys(errors).length === 0) {
            if (formData.ClientName == null || formData.ClientName == undefined || formData.ClientName == '') {
                toast.error("Please enter the client name", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if (formData.CompanyName == null || formData.CompanyName == undefined || formData.CompanyName == '') {
                toast.error("Please enter the company name", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if (formData.Email !== null && formData.Email !== undefined && formData.Email !== '') {

                if (!validateEmail(formData.Email)) {
                    toast.error("Please enter the valid email", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return true;
                }
            }
            const usrDetails = JSON.parse(localStorage.getItem("user"));
            formData.UserId = usrDetails.Id;
            const data = await ApiRequest(ApiEndpoints.Entity.CreateClient, ApiEndpointMethod.Post, formData, navigate);

            if (data.success == true) {
                fetchClients(currentPage, pageSize);
                document.getElementById('btnc').click();
                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                await clear();
            }
            else {
                toast.error(data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

        } catch (error) {
            // Handle network errors or any other errors
            console.error("There was an error sending the form data", error);
            toast.success(error, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        finally {
        }
    };


    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Clients</h5>
                            <div className="d-flex align-items-center">
                                <input className="form-control me-2" placeholder="search..."
                                    onChange={handleChanges} onKeyDown={handleKeyPress} value={search}
                                    type="search" style={{ width: '220px' }} />
                                <button className="btn btn-sm btn-info" id="mdlAddClient" data-bs-toggle="modal"
                                    data-bs-target="#addClient">
                                    <i className="fas fa-plus me-1"></i>Add Client
                                </button>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="table table-striped table-bordered bg-white mb-0">
                                <thead>
                                    <tr>
                                        <th width="20%">Name</th>
                                        <th width="20%">Company Name</th>
                                        <th width="20%">Timezone</th>
                                        <th width="5%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lstClient?.map((client) => (
                                        <React.Fragment key={client.Id}>
                                            <tr>
                                                <td onClick={() => updateRow(client.Id, !client.IsExpend)} style={{ cursor: "pointer" }}>
                                                    {client.IsExpend && (
                                                        <a className="text-muted me-2">
                                                            <small><i className="fas fa-caret-down"></i></small></a>
                                                    )}
                                                    {!client.IsExpend && (
                                                        <a className="text-muted me-2">
                                                            <small><i className="fas fa-caret-right"></i></small></a>
                                                    )}
                                                    {client.ClientName}
                                                </td>
                                                <td>{client.CompanyName}</td>
                                                <td>{client.TimeZone}</td>
                                                <td className="text-center">
                                                    <a className="text-primary me-2" data-bs-toggle="tooltip" title="Edit" onClick={() => { EditClient(client.Id) }}>
                                                        <i className="fas fa-edit"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                            {client.IsExpend == true && (
                                                <tr>
                                                    <td colSpan="4" className="ps-4">
                                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link active" id="fixed-tab" data-bs-toggle="tab" data-bs-target="#fixed" type="button"
                                                                    role="tab" aria-controls="fixed" aria-selected="true">Projects</button>
                                                            </li>
                                                            {/* <li class="nav-item" role="presentation">
                                                                <button class="nav-link" id="billable-tab" data-bs-toggle="tab" data-bs-target="#billable" type="button"
                                                                    role="tab" aria-controls="billable" aria-selected="false">Billable</button>
                                                            </li>
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link" id="support-tab" data-bs-toggle="tab" data-bs-target="#support" type="button"
                                                                    role="tab" aria-controls="support" aria-selected="false">Support</button>
                                                            </li> */}
                                                        </ul>

                                                        <div class="tab-content border-top-0 bg-lite shadow-sm" id="myTabContent">
                                                            <div class="tab-pane fade show active" id="fixed" role="tabpanel" aria-labelledby="fixed-tab">
                                                                <table className="table table-sm table-bordered bg-white mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="30%">Project Name</th>
                                                                            <th width="15%">Start Date</th>
                                                                            <th width="15%">Last Timesheet entry</th>
                                                                            <th width="15%">Estimated Hours</th>
                                                                            <th width="15%">Type</th>
                                                                            <th width="15%">Status</th>
                                                                            <th width="10%" className="text-center">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {client?.lstProjects?.map((project) => (
                                                                            <tr>
                                                                                <td>{project.Name}</td>
                                                                                <td>{formatDateUTCDate(project.StartDate)}</td>
                                                                                <td>{formatDateUTCDate(project.LastTimeEntry)}</td>
                                                                                <td style={{textAlign:"right"}}>{project.EstimateHours}</td>
                                                                                <td>{typeLabels[project.TypeId]}</td>
                                                                                <td>{statusLabels[project.StatusId]}</td>
                                                                                <td className="text-center">
                                                                                    <a className="text-success" data-bs-toggle="modal"
                                                                                        data-bs-target="#projectView" onClick={() => { fetchProjectDetails(project.Id) }} title="View">
                                                                                        <i className="fas fa-eye"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="tab-pane fade" id="billable" role="tabpanel" aria-labelledby="billable-tab">
                                                                Billable
                                                            </div>
                                                            <div class="tab-pane fade" id="support" role="tabpanel" aria-labelledby="support-tab">
                                                                Support
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    {/* <tr>
                                        <td>Joe West</td>
                                        <td>Hidden</td>
                                        <td>GMT-5</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-bs-toggle="tooltip" title="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-bs-toggle="tooltip" title="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Oliver Queen</td>
                                        <td>Novafai</td>
                                        <td>GMT-7</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-bs-toggle="tooltip" title="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-bs-toggle="tooltip" title="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>

                        <div className="pagination-wrapper shadow-sm">
                            <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                            <ul className="pagination">
                                <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </a>
                                </li>

                                {getPageNumbers().map((page) => (
                                    <li key={page} >
                                        <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                            {page}
                                        </a>
                                    </li>
                                ))}

                                <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>


                    </div>
                </div>
            </div>

            <div className="modal fade" id="addClient" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Client</h5>
                            <button type="button" className="btn-close" id="btnc"
                                data-bs-dismiss="modal" onClick={() => { clear(); }}></button>
                        </div>
                        <Formik
                            enableReinitialize={true}
                            initialValues={formData}
                            validationSchema={addClient()}
                            onSubmit={(values, actions) => {
                                CreateClient(values);
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange1,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                                setTouched,
                                validateForm,
                            }) => (
                                <form>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label>Client Name<span className="text-danger">*</span></label>
                                            <input className="form-control" type="text"
                                                value={formData?.ClientName}
                                                name="ClientName"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 50)
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Company Name<span className="text-danger">*</span></label>
                                            <input className="form-control" type="text"
                                                value={formData?.CompanyName}
                                                name="CompanyName"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 50)
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Email<span className="text-danger"></span></label>
                                            <input className="form-control" type="text"
                                                value={formData?.Email}
                                                name="Email"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 50)
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Timezone<span className="text-danger"></span></label>
                                            <input className="form-control" type="text"
                                                value={formData?.TimeZone}
                                                name="TimeZone"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 50)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" id="btnClose" className="btn btn-sm btn-outline-info me-2"
                                            data-bs-dismiss="modal" onClick={() => { clear(); }}>
                                            <i className="fas fa-times me-2"></i>Cancel
                                        </button>
                                        <button type="button" className="btn btn-sm btn-info"
                                            onClick={() => CreateClient(validateForm, setTouched, values)}>
                                            <i className="fas fa-check me-2"></i>Save
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="projectView" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{projectDetails?.projectDTO?.Name}</h5>
                            <button type="button" className="btn-close" id="btnc"
                                data-bs-dismiss="modal" onClick={() => { clear(); }}></button>
                        </div>
                        <div className="modal-body">
                            <div className="bg-lite rounded shadow-sm data-card mb-3">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div className="py-3">
                                            <p>Start Date</p>
                                            <h6 className="mb-0">{formatDateUTCDate(projectDetails?.projectDTO?.StartDate)}</h6>
                                        </div>
                                        <div className="data-card-item py-3">
                                            <p>Non-Billable Hours</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.NonBillable}</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="py-3">
                                            <p>Last Timesheet Entry</p>
                                            <h6 className="mb-0">{formatDateUTCDate(projectDetails?.projectDTO?.LastTimeEntry)}</h6>
                                        </div>
                                        <div className="py-3">
                                            <p>Total Hours</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.TotalDuration}</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="py-3">
                                            <p>Estimated Hours</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.EstimateHours}</h6>
                                        </div>
                                        <div className="py-3">
                                            <p>Utilized Percentage</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.Utilized.toFixed(2)}%</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="py-3">
                                            <p>Billable Hours</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.Billable}</h6>
                                        </div>
                                        <div className="py-3">
                                            <p>Exceeded Billable Hours</p>
                                            <h6 className="mb-0">{projectDetails?.projectDTO?.ExceededHours}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ul class="nav nav-tabs border-bottom-0 mb-3" id="myTab" role="tablist">
                                <li class="nav-item me-2" role="presentation">
                                    <button class="nav-link active" id="hoursUsed-tab" data-bs-toggle="tab" data-bs-target="#hoursUsed" type="button"
                                        role="tab" aria-controls="hoursUsed" aria-selected="true">Hours Used</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="resource-tab" data-bs-toggle="tab" data-bs-target="#resource" type="button"
                                        role="tab" aria-controls="resource" aria-selected="false">Resource</button>
                                </li>
                            </ul>

                            <div class="tab-content border-top-0" id="myTabContent">
                                <div class="tab-pane fade show active table-wrapper tab-table" id="hoursUsed" role="tabpanel" aria-labelledby="hoursUsed-tab">
                                    <table className="table table-striped table-bordered bg-white mb-0">
                                        <thead>
                                            <tr>
                                                <th width="25%">Month</th>
                                                <th width="25%" className="text-center">Billable Hours</th>
                                                <th width="25%" className="text-center">Non-Billable Hours</th>
                                                <th width="25%" className="text-center">Total Hours</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {projectDetails?.lstProjectTimeSheetDTO?.map((client) => (
                                               <React.Fragment key={client.Id}>
                                               <tr>
                                                <td>{client?.MonthName}</td>
                                                <td className="text-center">{client?.Billable}</td>
                                                <td className="text-center">{client?.NonBillable}</td>
                                                <td className="text-center">{client?.TotalDuration}</td>
                                                </tr>
                                              </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div class="tab-pane fade table-wrapper tab-table" id="resource" role="tabpanel" aria-labelledby="resource-tab">
                                    <table className="table table-bordered bg-white mb-0">
                                        <thead>
                                            <tr>
                                                <th width="40%">Name</th>
                                                <th width="30%">First Timesheet Entry</th>
                                                <th width="30%">Last Timesheet Entry</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                             {projectDetails?.lstProjectTimeSheetUserDTO?.map((client) => (
                                               <React.Fragment key={client.Id}>
                                               <tr>
                                                <td className="">{client?.Name}</td>
                                                <td className="text-center">{formatDateUTCDate(client?.FirstTimeEntry)}</td>
                                                <td className="text-center">{formatDateUTCDate(client?.LastTimeEntry)}</td>
                                                </tr>
                                              </React.Fragment>
                                            ))}
                                            {/* <tr>
                                                <td>Rachel</td>
                                                <td>05/05/2024</td>
                                                <td>05/11/2025</td>
                                            </tr>
                                            <tr>
                                                <td>Vinoth</td>
                                                <td>10/08/2024</td>
                                                <td>05/11/2025</td>
                                            </tr>
                                            <tr>
                                                <td>Preethi</td>
                                                <td>10/08/2024</td>
                                                <td>05/11/2025</td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            {loader && (
                <Loader />
            )}
        </>
    )
}

export default Clients;